import { selectAuth } from '@/services/auth'
import { useSelector } from '@/state/reducer'

export const useAuth = () => {
  const { user, authenticated } = useSelector(selectAuth)

  return {
    user,
    authenticated,
  }
}

export default useAuth
